import * as React from "react";
const SvgFiRrPenClipSlash = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-pen-clip-slash_svg__a)">
      <path
        fill="#062147"
        d="M11.81 15.924a1 1 0 0 1 0 1.414l-4.596 4.595a3.63 3.63 0 0 1-2.574 1.064 3.64 3.64 0 0 1-1.767-.456l-1.165 1.165a.997.997 0 0 1-1.414 0 1 1 0 0 1 0-1.414l1.164-1.164a3.6 3.6 0 0 1-.457-1.769 3.62 3.62 0 0 1 1.066-2.574l4.565-4.565a.999.999 0 1 1 1.414 1.414L3.481 18.2c-.31.31-.48.722-.48 1.16s.171.85.48 1.16a1.64 1.64 0 0 0 2.32 0l4.594-4.596a1 1 0 0 1 1.414.001m11.897 7.783a.997.997 0 0 1-1.414 0l-22-22A.999.999 0 1 1 1.707.293l5.588 5.588 2.407-2.407a4.97 4.97 0 0 1 3.535-1.465 4.96 4.96 0 0 1 2.77.836l1.672-1.672C19.044-.194 21.233-.35 22.66.817a3.66 3.66 0 0 1 1.336 2.642 3.65 3.65 0 0 1-1.062 2.756l-7.653 7.653 8.426 8.426a1 1 0 0 1 0 1.414zm-9.84-11.254 4.528-4.528-2.319-2.319-4.528 4.528zm3.623-8.26 2.32 2.318 1.71-1.71c.327-.328.502-.78.48-1.243a1.63 1.63 0 0 0-.607-1.193c-.64-.524-1.649-.426-2.298.223zM8.71 7.295l1.423 1.424 4.401-4.4c-1.114-.512-2.527-.323-3.418.57z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-pen-clip-slash_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrPenClipSlash;
